import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { IonButton } from '@ionic/angular/standalone';

@Component({
  selector: 'x-load-more',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonButton],
  templateUrl: './x-load-more.component.html',
  styleUrl: './x-load-more.component.scss',
})
export class XLoadMoreComponent {
  loading = input(false);
  clicked = output<void>();
}
